import {
  AfterViewInit,
  Directive,
  ElementRef,
  HostListener,
  Input
} from '@angular/core';
import { IDataUrlParam } from 'src/app/shared/framework/images/models/DataUrlParam';

@Directive({
  selector: '[appFileLink]'
})
export class FileLinkDirective implements AfterViewInit {
  public constructor(private element: ElementRef) { }
  @Input() appFileLink: IDataUrlParam;

  public ngAfterViewInit(): void {
    const parentElement = this.element.nativeElement as HTMLElement;
    parentElement.classList.add('cursor-pointer');
  }

  @HostListener('click')
  public openAttachment(): void {
    const binaryData = [];
    const binaryString = window.atob(this.appFileLink.fileData);
    const bytes = new Uint8Array(+this.appFileLink.fileSize);
    const result = bytes.map((byte, i) => binaryString.charCodeAt(i));
    binaryData.push(result);
    const blob: Blob = new Blob(binaryData, {
      type: this.appFileLink.contentType
    });

    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    document.body.appendChild(a);
    a.setAttribute('style', 'display: none');
    a.href = url;
    a.download = this.appFileLink.fileName;
    a.click();
    window.URL.revokeObjectURL(url);
    a.remove();
  }
}
